import { api } from 'common';

import { getScriptedFlowBlockDefaultConfig } from './constants';
import { SCRIPTED_FLOW_DOCUMENTATION_MARKDOWN } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { SharedFunctionBlockFormFields } from '../../ConfigFields/JavaScriptBlock/FormFields';
import { type BlockConfigProps } from '../../types';

export const scriptedFlowConfig: BlockConfigProps<api.FlowDefinition.ScriptedFlowBlock['config']> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'script',
    defaultConfig: getScriptedFlowBlockDefaultConfig(),
    configFields: {
      getLanguageFieldValues: (config) => {
        return {
          [CodeMirrorLanguageType.JavaScriptAndNodeFields]: [config.fn],
        };
      },
      schema: api.FlowDefinition.ScriptedBlockConfigSchema,
      FormFields: SharedFunctionBlockFormFields,
    },
    documentationMarkdown: SCRIPTED_FLOW_DOCUMENTATION_MARKDOWN,
  };
